// Shuffle JS Array
// source: https://www.w3resource.com/javascript-exercises/javascript-array-exercise-17.php
 
const shuffle = (arrayList) => {
    var ctr = arrayList.length, temp, index;
    // While there are elements in the array
    while (ctr > 0) {
        // Pick a random index
        index = Math.floor(Math.random() * ctr);
        // Decrease ctr by 1
        ctr--;
        // And swap the last element with it
        temp = arrayList[ctr];
        arrayList[ctr] = arrayList[index];
        arrayList[index] = temp;
    }
    return arrayList;
}

export default shuffle